function showReadMoreText() {
  var moreText = document.querySelectorAll("#more");
  var btnReadMore = document.getElementById("read-more");

  if (btnReadMore) {

    btnReadMore.addEventListener("click", (event) => {

      moreText[0].classList.toggle("mobile-tablet-display-none");
      moreText[1].classList.toggle("mobile-tablet-display-none");

      if (moreText[0].classList.contains("mobile-tablet-display-none") && moreText[1].classList.contains("mobile-tablet-display-none")) {
        btnReadMore.innerHTML = "Voir plus";
      } else {
        btnReadMore.innerHTML = "Voir moins";
      }

    });
  }
}

export { showReadMoreText };
